<template>
  <div @click="logout">
    {{$t("user.logout")}}
  </div>
</template>

<script>
export default {
  name: 'DefaultHeaderDropdown',
  methods: {
    logout: async function() {
      try {
        await this.$store.dispatch("session/AUTH_LOGOUT");
        this.$router.push({
          name: "Login"
        });
      } catch(error) {
        throw error;
      }
    }
  }
}
</script>

